import { IGlobalState } from '~reducer';
import IAggregator from '~Api/Aggregator/IAggregator';
import { IDictionary } from '~utilities/IDictionary';

export function aggregatorsSelector(state: IGlobalState): IDictionary<IAggregator> {
    return state.aggregators.aggregators;
}
